export const commonFeedConstants = {
  GET_FEEDS_REQUEST: 'COMMONFEED/GET_FEEDS_REQUEST',
  GET_FEEDS_SUCCESS: 'COMMONFEED/GET_FEEDS_SUCCESS',
  GET_FEEDS_FAILURE: 'COMMONFEED/GET_FEEDS_FAILURE',

  POST_MESSAGE_REQUEST: 'COMMONFEED/POST_MESSAGE_REQUEST',
  POST_MESSAGE_SUCCESS: 'COMMONFEED/POST_MESSAGE_SUCCESS',
  POST_MESSAGE_FAILURE: 'COMMONFEED/POST_MESSAGE_FAILURE',
  //RESET_AFTER_MESSAGE_POSTED: 'COMMONFEED/RESET_AFTER_MESSAGE_POSTED',

  EDIT_MESSAGE_REQUEST: 'COMMONFEED/EDIT_MESSAGE_REQUEST',
  EDIT_MESSAGE_SUCCESS: 'COMMONFEED/EDIT_MESSAGE_SUCCESS',
  EDIT_MESSAGE_FAILURE: 'COMMONFEED/EDIT_MESSAGE_FAILURE',

  DELETE_MESSAGE_REQUEST: 'COMMONFEED/DELETE_MESSAGE_REQUEST',
  DELETE_MESSAGE_SUCCESS: 'COMMONFEED/DELETE_MESSAGE_SUCCESS',
  DELETE_MESSAGE_FAILURE: 'COMMONFEED/DELETE_MESSAGE_FAILURE',

  ADD_REACTION_REQUEST: 'COMMONFEED/ADD_REACTION_REQUEST',
  ADD_REACTION_SUCCESS: 'COMMONFEED/ADD_REACTION_SUCCESS',
  ADD_REACTION_FAILURE: 'COMMONFEED/ADD_REACTION_FAILURE',

  DELETE_REACTION_REQUEST: 'COMMONFEED/DELETE_REACTION_REQUEST',
  DELETE_REACTION_SUCCESS: 'COMMONFEED/DELETE_REACTION_SUCCESS',
  DELETE_REACTION_FAILURE: 'COMMONFEED/DELETE_REACTION_FAILURE',

  SET_ORIGIN_MESSAGE_ID: 'COMMONFEED/SET_ORIGIN_MESSAGE_ID',

  DELETE_FILE_FROM_MESSAGE_REQUEST: 'COMMONFEED/DELETE_FILE_FROM_MIXR_REQUEST',
  DELETE_FILE_FROM_MESSAGE_SUCCESS: 'COMMONFEED/DELETE_FILE_FROM_MESSAGE_SUCCESS',
  DELETE_FILE_FROM_MESSAGE_FAILURE: 'COMMONFEED/DELETE_FILE_FROM_MESSAGE_FAILURE',

  PIN_MESSAGE_REQUEST: 'COMMONFEED/PIN_MESSAGE_REQUEST',
  PIN_MESSAGE_SUCCESS: 'COMMONFEED/PIN_MESSAGE_SUCCESS',
  PIN_MESSAGE_FAILURE: 'COMMONFEED/PIN_MESSAGE_FAILURE',

  UNPIN_MESSAGE_REQUEST: 'COMMONFEED/UNPIN_MESSAGE_REQUEST',
  UNPIN_MESSAGE_SUCCESS: 'COMMONFEED/UNPIN_MESSAGE_SUCCESS',
  UNPIN_MESSAGE_FAILURE: 'COMMONFEED/UNPIN_MESSAGE_FAILURE',

  SAVE_DRAFT_TO_STATE: 'COMMONFEED/SAVE_DRAFT_TO_STATE',

  ADD_DRAFT_NEWSFEED_REQUEST: 'COMMONFEED/ADD_DRAFT_NEWSFEED_REQUEST',
  ADD_DRAFT_NEWSFEED_SUCCESS: 'COMMONFEED/ADD_DRAFT_NEWSFEED_SUCCESS',
  ADD_DRAFT_NEWSFEED_FAILURE: 'COMMONFEED/ADD_DRAFT_NEWSFEED_FAILURE',

  TRANSLATE_MESSAGE_REQUEST: 'COMMONFEED/TRANSLATE_MESSAGE_REQUEST',
  TRANSLATE_MESSAGE_SUCCESS: 'COMMONFEED/TRANSLATE_MESSAGE_SUCCESS',
  TRANSLATE_MESSAGE_FAILURE: 'COMMONFEED/TRANSLATE_MESSAGE_FAILURE',

  GET_FEED_BLOCK_REQUEST: 'COMMONFEED/GET_FEED_BLOCK_REQUEST',
  GET_FEED_BLOCK_SUCCESS: 'COMMONFEED/GET_FEED_BLOCK_SUCCESS',
  GET_FEED_BLOCK_FAILURE: 'COMMONFEED/GET_FEED_BLOCK_FAILURE',

  SELECTED_NEWSFEED: 'COMMONFEED/SELECTED_NEWSFEED',

  LOCATE_POST_IN_NEWSFEED_REQUEST: 'COMMONFEED/LOCATE_POST_IN_NEWSFEED_REQUEST',
  LOCATE_POST_IN_NEWSFEED_SUCCESS: 'COMMONFEED/LOCATE_POST_IN_NEWSFEED_SUCCESS',
  LOCATE_POST_IN_NEWSFEED_FAILURE: 'COMMONFEED/LOCATE_POST_IN_NEWSFEED_FAILURE',

  CREATE_BG_TAG_REQUEST: 'COMMONFEED/CREATE_BG_TAG_REQUEST',
  CREATE_BG_TAG_SUCCESS: 'COMMONFEED/CREATE_BG_TAG_SUCCESS',
  CREATE_BG_TAG_FAILURE: 'COMMONFEED/CREATE_BG_TAG_FAILURE',

  REMOVE_PROCESSED_TAG: 'COMMONFEED/REMOVE_PROCESSED_TAG',
  UPDATE_TAG_COUNT: 'COMMONFEED/UPDATE_TAG_COUNT',

  GET_SHARING_TAG_FILES_REQUEST: 'COMMONFEED/GET_SHARING_TAG_FILES_REQUEST',
  GET_SHARING_TAG_FILES_SUCCESS: 'COMMONFEED/GET_SHARING_TAG_FILES_SUCCESS',
  GET_SHARING_TAG_FILES_FAILURE: 'COMMONFEED/GET_SHARING_TAG_FILES_FAILURE',

  REMOVE_SHARING_PROCESSED_TAG_FILES: 'COMMONFEED/REMOVE_SHARING_PROCESSED_TAG_FILES',
  SET_PENDING_MESSAGE_COUNT: 'COMMONFEED/SET_PENDING_MESSAGE_COUNT'
}
